<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <!-- <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Create Subjective Question Bank
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center">
             <v-col sm="3" v-if="crs_list!=null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="crs" item-value="crs_id" :items="crs_list" item-text="crs_name" label="Subject" outlined  @change="getchapter()"/>
                </v-col>
                <v-col sm="3" v-if="chapter_list!=null && crs">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="chapter" item-value="ch_id" :items="chapter_list" item-text="ch_name" label="Chaper" outlined @change="getQuestionBank()"/>
                </v-col>
            </v-row> -->
      <span v-if="chapter">
        <span class="slide">*NOTE:Question Image File size Should be less than
          {{ imagesize_new }} KB And It Should be in
          <span v-for="(img, index) in imagetype_new" :key="index">
            {{ img.imagetype }} </span>Format!!!</span>
        <v-row dense justify="center"><strong>Question No. {{ question_size }}</strong></v-row>
        <v-card class="box">
          <v-row justify="center">
            <span v-if="imageSizeFlag">
              <v-col cols="12" xs="12" sm="12">
                <p class="slide">
                  Question File size should be less than {{ imagesize_new }}KB!
                </p>
              </v-col>
            </span>
            <span v-if="imageTypeFlag">
              <v-col cols="12" xs="12" sm="12">
                <p class="slide">
                  Question File in
                  <span v-for="(img, index) in imagetype_new" :key="index">
                    {{ img.imagetype }}
                  </span>
                  Format!!!
                </p>
              </v-col>
            </span>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="1" md="1">
              <v-text-field color="#0F2027" label="Marks" v-model.trim="weightage" type="number"
                required></v-text-field>
            </v-col>
            <v-col cols="12" sm="1" md="1"></v-col>
            <!-- <v-col cols="12" sm="3">
              <v-checkbox
                color="#0F2027"
                v-model="isapprove"
                class="mx-2"
                label="Is Approve"
              ></v-checkbox>
            </v-col> -->
            <v-col cols="12" sm="6" md="6">
              <ckeditor v-model="question" :config="editorConfig"></ckeditor>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-col cols="12" sm="10">
                <v-file-input v-model="qfile" id="file" prepend-icon="mdi-attachment" label="Choose File" show-size
                  name="doc" accept="image/*" @change="validateFile()"></v-file-input>
              </v-col>
            </v-col>
          </v-row>
          <br>
          <v-row dense justify="center">
            <v-col cols="12" sm="6" md="6">
              <v-textarea label="Add Correct Answer / Model Answer" auto-grow v-model="correct_answer" outlined rows="3"
                :rules="[(v) => !!v || 'Answer is required']"></v-textarea>
            </v-col>
          </v-row>
        </v-card>
        <v-row justify="center">
          <v-btn class="button" @click="savesubjective">Save</v-btn>
        </v-row>
      </span>
    </v-card>
    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please Wait
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: {
    type: String,
    //  chapter:String, // changed to number
    chapter: Number,
    Level: Number,
    crs: Number,
  },
  data() {
    return {
      correct_answer: null,
      editorConfig: {
        height: "100px",
        extraPlugins: "mathjax",
        mathJaxLib:
          "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
      },
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: null,
      overlay: false,
      crs_list: null,
      // crs: null,
      chapter_list: null,
      //   chapter: null,
      qfile: null,
      isapprove: true,
      weightage: 1,
      question: null,
      question_size: null,
      imagesizeflaginputs: false,
      imagesizetypeinputs: false,
      imagesize: null,
      imageSizeFlag: false,
      imageTypeFlag: false,
      dialog_zooimg: false,
      dialog_save: false,
      dialog_save_option: false,
      dialog_upload: false,
      imagesize_new: null,
      imagetype_new: null,
    };
  },
  updated: function () {
    this.$nextTick().then(() => {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub], () =>
          console.log("done")
        );
      }
    });
  },
  methods: {
    savesubjective() {
      let formData = new FormData();
      if (this.imagesizeflaginputs) {
        this.showSnackbar("#b71c1c", "Please check file size!!!"); // show snackbar
        return false;
      }
      if (this.imagesizetypeinputs) {
        this.showSnackbar("#b71c1c", "Please check file extension!!!"); // show snackbar
        return false;
      }
      formData.append("qfile", this.qfile);
      formData.append("weightage", this.weightage);
      formData.append("question", this.question);
      formData.append("isapprove", this.isapprove);
      formData.append("ch_id", this.chapter);
      formData.append("Level_id", this.Level);
      formData.append("crs_id", this.crs);
      formData.append("type", this.type);
      formData.append("correct_answer", this.correct_answer);
      if (this.qfile == null && this.question == "") {
        this.showSnackbar("#b71c1c", "Please Add The Question !!!"); // show snackbar
        return;
      }
      if (this.correct_answer == "" || this.correct_answer == null) {
        this.showSnackbar("#b71c1c", "Please Add Correct / Model Answer !!!"); // show snackbar
        return;
      }
      this.dialog_upload = true;
      axios
        .post("/QuizQuestionBank/saveBank", formData, {})
        .then((res) => {
          if (res.data.flagiscorrect == "notselected") {
            this.dialog_upload = false;
            this.showSnackbar("#b71c1c", "Please Select Correct Option!!!");
          }
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully...");
            this.dialog_upload = false;
            this.reset();
            this.getQuestionBank();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong !!!");
          this.dialog_upload = false;
        })
        .finally(() => {
          this.isapprove = true;
        });
    },
    reset() {
      (this.question = null), (this.qfile = null), (this.weightage = 1);
      this.correct_answer = null
    },
    validateFile() {
      let file = this.qfile;
      let file_size = file.size;
      let file_name = this.qfile.name;
      let ext = file_name.split(".").pop();
      const data = {
        type: this.type,
      };
      axios
        .post("/QuizQuestionBank/validatefile", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.imagesize = res.data.imagesize;
            if (file_size > this.imagesize) {
              //200kb
              this.imageSizeFlag = true;
              this.qfile = null;
            } else {
              this.imageSizeFlag = false;
            }
            this.imagetype = res.data.imagetype;
            //console.log(this.imagetype)
            for (var i = 0; i < this.imagetype.length; i++) {
              //alert(i)
              //alert(this.imagetype[i].imagetype)
              if (ext == this.imagetype[i].imagetype) {
                // alert("in if")
                this.imageTypeFlag = false;
                return;
              }
            }
            for (var i = 0; i < this.imagetype.length; i++) {
              if (ext != this.imagetype[i].imagetype) {
                // alert("in else new for")
                this.imageTypeFlag = true;
                this.qfile = null;
                return;
              }
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.onerror(error);
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getCourse() {
      axios
        .post("/QuizQuestionBank/getCourse")
        .then((res) => {
          this.crs_list = res.data.crs_list;
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    getchapter() {
      const data = {
        crs_id: this.crs,
      };
      axios
        .post("/QuizQuestionBank/getchapter", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar(
              "#b71c1c",
              "Please add chapter for selected course !!!"
            );
            return;
          } else {
            this.chapter_list = res.data.chapter_list;
          }
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    getQuestionBank() {
      const data = {
        crs_id: this.crs,
        ch_id: this.chapter,
        Level_id: this.Level,
        type: this.type,
      };
      axios
        .post("/QuizQuestionBank/getQuestionBank", data)
        .then((res) => {
          this.question_size = res.data.question_size;
          this.imagesize_new = res.data.imagesize / 1000;
          this.imagetype_new = res.data.imagetype;
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
    getdifficultylevel() {
      const data = {

      };
      axios
        .post("/QuizQuestionBank/getdifficultylevel", data)
        .then((res) => {
          if (res.data.flag == "NO") {
            this.showSnackbar("#b71c1c", "Please add Level...!!!");
            return
          }
          else {
            this.Level_list = res.data.difficulty_level_list;
          }
        })
        .catch((error) => {
          window.console.log(error);

          this.showSnackbar("#b71c1c", "Something went wrong !!!");
        })
        .finally(() => {
          //close loader
        });
    },
  },
  mounted() {
    // alert(this.type)
    this.getQuestionBank();
  },
};
</script>
<style scoped>
.radiospace {
  margin: 0.5rem !important;
  padding: 0%;
}

.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
</style>
